// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"94d82fb1","115":"a66fb7a3","222":"5a73b301","280":"72ea9bd8","354":"92c158cb","444":"f9db5d39","510":"321a5437","563":"cbb2f55a","567":"69e69b75","739":"21036e02","860":"e72f930d","928":"d979bf35"}[chunkId] + ".chunk.js";
};